import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function rawProgramReducer(state = initialState.rawPrograms, action) {
  switch (action.type) {
    case types.RAW_PROGRAMS:
      return action.rawPrograms;

    case types.RAW_PROGRAMS_UPDATE:
      return {
        ...state, 
        programs: action.programs
      };  

    default:
      return state;
  }
}